import { RouteVariables } from 'types/routesTypes'
import { INewsState } from 'types/newsTypes'
import { ImagesPostNews } from 'images/posts'

const initialState: INewsState = {
  allNews: [
    {
      id: 1,
      img: ImagesPostNews.ImagePost_1,
      title: 'Требуются сотрудники',
      postDate: '14 февраля, 2022',
      postTag: 'Все новости',
      category: 'all',
      postText:
        'Открыта вакансия бухгалтера и оператора экструдера. <br/><a href="/vakansii">Наши вакансии.</a>',
      more: true,
    },
    {
      id: 2,
      img: ImagesPostNews.ImagePost_2,
      title: 'Мы обновили сайт!',
      postDate: '22 декабря, 2021',
      postTag: 'Все новости',
      category: 'all',
      postText:
        'Уважаемые наши клиенты! У нас отличная новость для Вас: мы обновили наш сайт. Мы постарались его сделать более удобным, современным, информативным.Он стал быстрее загружаться на всех устройствах, и Вы теперь сможете просматривать любую интересную Вам информацию на сайте с более позитивным настроением! Очень надеемся, что новые изменения понравятся Вам и помогут быстрее найти и заказать ту продукцию, которая Вам необходима! Если у Вас есть предложения или вопросы по работе нового сайта, пожалуйста, направляйте их нам на почту: qplast@tut.by. С уважением, команда ООО «КЮ Пласт Тех».',
      more: false,
    },
    {
      id: 3,
      img: ImagesPostNews.ImagePost_3,
      title:
        'В Mile можно купить в розницу наш уплотнитель для ремонта ПВХ окон',
      postDate: '23 ноября, 2021',
      postTag: 'Все новости',
      category: 'all',
      postText: `
        <p>С 24.11.2021 можно купить уплотнитель для ремонта ПВХ окон (притворный универсальный Ок КВЕ 228) в индивидуальной упаковке по 12 м.п. в торговом объекте «Mile», расположенном по следующим адресам:</p>
        <ul>
          <li>г. Минск, пр-т Независимости, 171;</li>
          <li>г. Минск, пр-т Партизанский, 150А, ТЦ «Момо»;</li>
          <li>г. Минск, пр-т Жукова, 44, ТЦ «OUTLETO»;</li>
          <li>г. Минск, тр-т Долгиновский,188, ТЦ «ALL House»;</li>
          <li>г. Минск, ул. Каменногорская, 3;</li>
          <li>г. Минск, ул. Тимирязева, 127, ТД «Ждановичи»;</li>
          <li>Минский р-н, Щомыслицкий с/с, 32/4, ТЦ «Диамант»;</li>
          <li>Минский р-н, Боровлянский с/с, 74/1, ТРК «Expobel»;</li>
          <li>г. Брест, ул. Карьерная, 9Б;</li>
          <li>г. Гродно, пр-т Янки Купалы 87, ТРК «Triniti»;</li>
          <li>г. Минск, пр-т Независимости, 171;</li>
          <li>г. Молодечно, ул. Великий Гостинец, 67Г.</li>
        </ul>
        <p>Информацию о монтаже уплотнителя смотрите по <Link to={'${RouteVariables.NEWS_ROUTE()}/4'}>ссылке.</Link></p>`,
      more: false,
    },
    {
      id: 4,
      img: ImagesPostNews.ImagePost_4,
      title: 'Монтаж уплотнителя для ремонта ПВХ окон',
      postDate: '23 ноября, 2021',
      postTag: 'Статьи',
      category: 'articles',
      postText:
        'Установка уплотнителя притворного универсального Ок KBE 228 (уплотнитель для ремонта ПВХ окон) осуществляется сверху вниз, при этом шов должен находиться наверху створки по середине оконной рамы. По всему периметру оконной рамы или створки размещаете уплотнитель в оконный паз, не растягивая его в углах рамы. Для лучшего монтажа уплотнителя в паз не забудьте смазать паз жидким мылом.',
      more: false,
    },
    {
      id: 5,
      img: ImagesPostNews.ImagePost_5,
      title: 'Обновление производства',
      postDate: '19 ноября, 2021',
      postTag: 'Все новости',
      category: 'all',
      postText:
        'Наше предприятие освоило выпуск погонажных изделий из разнообразных пластмасс. Есть возможность нанесения рисунка на поверхность профиля. Теперь мы быстро и качественно можем изготовить любой профиль.',
      more: false,
    },
    {
      id: 6,
      img: ImagesPostNews.ImagePost_6,
      title: 'Новый адрес производства',
      postDate: '28 октября, 2019',
      postTag: 'Все новости',
      category: 'all',
      postText:
        'Производство нашего предприятия теперь находится по новому адресу: Республика Беларусь, Минская область, Минский район, Михановичский с/с, район п. Михановичи, производственно-складская база, здание авторемонтных Координаты для навигации: 53.754474, 27.683383.',
      more: false,
    },
    {
      id: 7,
      img: ImagesPostNews.ImagePost_7,
      title: 'Сотрудничество',
      postDate: '14 июня, 2018',
      postTag: 'Все новости',
      category: 'all',
      postText:
        'Сотрудничество по изготовлению изделий из пластмасс методом экструзии из разнообразных материалов: ПВХ, ТЭП. Малые партии от 200 м.п. Срок изготовления — от 2-х дней.',
      more: false,
    },
    {
      id: 8,
      img: ImagesPostNews.ImagePost_8,
      title: 'Скупка ПВХ и ТЭП',
      postDate: '23 декабря, 2017',
      postTag: 'Все новости',
      category: 'all',
      postText: `
      <h2>Предприятие на постоянной основе покупает пластифицированный ПВХ и ТЭП на основе SEBS.</h2>
      <p>
        Приглашаем к сотрудничеству производителей полимерного сырья.
      </p>
      <p>
        SEBS полимеры (Стирол-Этилен-Бутилен-стирол) зарекомендовали себя на международном и внутреннем рынках, как очень надёжные и прочные. Немаловажной особенностью является его совместимость с минеральными маслами, а также полиолефинами.
      </p>`,
      more: false,
    },
  ],
}

export const newsReducer = (state = initialState): INewsState => state
